import eLife from '@/views/eLife'

export default {
  path: '/eLife',
  component: eLife,
  name: 'eLife',
  meta: {
    title: '我的'
  },
  children: [
    {
      path: 'policy',
      component: () => import('@/views/eLife/Policy'),
      name: 'Policy',
      meta: {
        title: '基本信息'
      }
    },
    {
      path: '/eLife/changepass',
      component: () => import('@/views/eLife/Changepass'),
      name: 'changepass',
      meta: { title: '修改密码' }
    },
    {
      path: '/eLife/caiadmin',
      component: () => import('@/views/eLife/Caiadmin'),
      name: 'Caiadmin',
      meta: { title: '个人信息' }
    },
    {
      path: '/eLife/Certification',
      component: () => import('@/views/eLife/Certification'),
      name: 'Certification',
      meta: { title: '公司认证' }
    },
    {
      path: '/eLife/Certlist',
      component: () => import('@/views/eLife/Certlist'),
      name: 'Certlist',
      meta: { title: '公司列表' }
    }
  ]
}
